/* tslint:disable */
/* eslint-disable */
export enum PersonAttributeName {
  SUBJECT_TO_US_TAX = 'SUBJECT_TO_US_TAX'
}
